import script from "./fileUploadTemplateDownload.vue?vue&type=script&setup=true&lang=js"
export * from "./fileUploadTemplateDownload.vue?vue&type=script&setup=true&lang=js"

import "./fileUploadTemplateDownload.vue?vue&type=style&index=0&id=e42393ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e42393ce"]])

export default __exports__